import React from 'react';
import { motion } from 'framer-motion';
import { trackCTAClick } from '../utils/metaPixel';
export function HeroSection() {
  const checkoutUrl = 'https://yennilemon.com/cart/44211058212999:1?country=MX&locale=es-MX';
  return <section className="relative bg-warm-white overflow-hidden pt-4 pb-8 md:py-20 lg:py-24 px-4" data-id="element-132">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-12 items-center" data-id="element-133">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-2 md:space-y-5" data-id="element-134">
          {/* Headline */}
          <h1 className="md:hidden text-[clamp(21px,5.8vw,28px)] font-heading font-bold text-olive leading-[1.15] text-center" data-id="element-135">
            ¿Te despiertas a las 3 am y amaneces agotada?
          </h1>
          <h1 className="hidden md:block text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-olive leading-tight" data-id="element-136">
            ¿Te despiertas a las 3 am y amaneces agotada?
          </h1>

          {/* Subheadline — 2 lines max on mobile */}
          <p className="text-[13px] md:text-xl text-warm-gray leading-snug md:leading-relaxed max-w-xl text-center md:text-left" data-id="element-137">
            <span className="md:hidden" data-id="element-138">
              No es casualidad. Puede ser inflamación y desbalance hormonal
              afectando tu descanso y energía.
            </span>
            <span className="hidden md:inline" data-id="element-139">
              No es casualidad. Después de los 40, la inflamación y el
              desbalance hormonal pueden afectar tu descanso, energía y abdomen.
              Este plan te ayuda a recuperar tu bienestar desde la raíz.
            </span>
          </p>

          {/* Mobile ebook image — compact */}
          <div className="md:hidden flex justify-center" data-id="element-140">
            <img src="https://cdn.magicpatterns.com/uploads/6vVttknJUee3FLPpQRrkQF/mockup3D.png" alt="Plan Antiinflamatorio Después de los 40" className="max-w-[200px] w-[75%] h-auto object-contain drop-shadow-2xl" data-id="element-141" />
          </div>

          {/* Pricing Block — tighter on mobile */}
          <div className="bg-cream border-2 border-sage rounded-2xl p-4 md:p-8 text-center max-w-md mx-auto lg:mx-0 shadow-soft relative" data-id="element-142">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-sage text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" data-id="element-143">
              👇 PRECIO DE LANZAMIENTO
            </div>

            <div className="flex items-center justify-center gap-2 text-warm-gray text-xs md:text-sm mt-1" data-id="element-144">
              <span className="line-through decoration-warm-accent/50" data-id="element-145">
                $497 MXN
              </span>
              <span className="bg-warm-accent text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-146">
                -75% OFF
              </span>
            </div>

            <div className="text-4xl md:text-6xl font-bold text-olive font-heading py-1" data-id="element-147">
              $114 <span className="text-xl md:text-3xl" data-id="element-148">MXN</span>
            </div>

            <p className="text-sage font-medium text-xs md:text-sm" data-id="element-149">
              Solo por 3 días · Oferta de lanzamiento
            </p>

            <a href={checkoutUrl} onClick={trackCTAClick} className="block w-full mt-4 bg-[#E8763A] hover:bg-[#D4682F] text-white font-extrabold py-3.5 md:py-4 px-6 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-sm md:text-lg text-center uppercase tracking-wide" data-id="element-150">
              SÍ, QUIERO EL PLAN POR SOLO $114 MXN
            </a>

            <p className="text-warm-gray text-[10px] md:text-xs mt-2 font-medium" data-id="element-151">
              Pago único • Descarga inmediata • Garantía 7 días
            </p>
            <p className="text-warm-gray/70 text-[10px] md:text-[11px] mt-1 leading-snug" data-id="element-152">
              🔒 Pago Seguro 100%. ¿Ayuda? 🇲🇽{' '}
              <a href="https://wa.me/16468066813?text=Hola%20Yenny,%20tengo%20una%20duda%20con%20el%20Plan%20Antiinflamatorio." target="_blank" rel="noopener noreferrer" className="text-[#25D366] font-semibold underline hover:text-[#1EBE5A]" data-id="element-153">
                WhatsApp
              </a>{' '}
              desde USA 🇺🇸
            </p>
          </div>
        </motion.div>

        {/* Image Content — desktop only */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative hidden lg:flex justify-center lg:justify-end" data-id="element-154">
          <div className="relative w-full max-w-lg" data-id="element-155">
            <div className="absolute inset-0 bg-sage/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-156"></div>
            <img src="https://cdn.magicpatterns.com/uploads/6vVttknJUee3FLPpQRrkQF/mockup3D.png" alt="Plan Antiinflamatorio Después de los 40" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-157" />
          </div>
        </motion.div>
      </div>
    </section>;
}